/**
 * Created by Andrey Popov on 4/25/25.
 */

const CupDataSource = function (cup) {
    cleverapps.EventEmitter.call(this);

    this.cup = cup;
    cleverapps.user.on("userInfoChanged", this.onChangeCupResults.bind(this), this);
    cup.onChangeResults = this.onChangeCupResults.bind(this);
};

CupDataSource.prototype = Object.create(cleverapps.EventEmitter.prototype);
CupDataSource.prototype.constructor = CupDataSource;

CupDataSource.prototype.getData = function () {
    const participants = this.cup.participants.map((participant) => ({
        id: participant.id,
        score: participant.score,
        data: {
            name: participant.name,
            avatar: participant.avatar
        }
    }));
    let player;

    for (let i = 0; i < participants.length; ++i) {
        if (participants[i].id === this.cup.participantId) {
            player = participants[i];
        }
    }

    const info = this.cup.getParticipantInfo();

    if (!player) {
        player = {
            id: info.id,
            data: {}
        };
        participants.push(player);
    }

    player.score = this.cup.score;
    player.pinned = true;
    player.data.player = true;
    player.data.avatar = info.avatar || player.data.avatar;
    player.data.name = info.name || player.data.name;

    participants.sort((a, b) => b.score - a.score);

    const rewards = this.cup.listRewards();

    participants.forEach((player, index) => {
        const place = index + 1;
        player.weight = -place;
        player.data.cup = this;
        player.data.place = place;

        if (this.cup.config.participateAsClan) {
            player.data.emblem = player.data.avatar;
        }

        if (rewards[index]) {
            player.data.prizeIcon = bundles.table.frames[`prize_${place}`] || bundles.table.frames.prize_5;
            player.data.prizeRewards = rewards[index];
        }
    });

    return participants;
};

CupDataSource.prototype.onChangeCupResults = function () {
    this.trigger("updateAll", true);
};

CupDataSource.prototype.destructor = function () {
    runCleaners(this);
    this.cup.onChangeResults = function () {};
};